import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@/lib/api/client';

import { customizationKeys } from './customizationKeys';
import { type TenantCustomization, tenantCustomizationSchema } from './useGetCustomization';

// PATCH /api/v1/tenants/me/logo (multipart) — uploads/replaces the org logo.
// Bytes go to object storage; the response carries a fresh presigned logoUrl.
// Backend enforces Tenant.Edit + validates size/type (magic bytes).
export function useUploadLogo() {
  const queryClient = useQueryClient();

  return useMutation<TenantCustomization, Error, File>({
    mutationFn: async (file) => {
      const form = new FormData();
      form.append('logo', file);
      const raw = await apiClient.patch('api/v1/tenants/me/logo', { body: form }).json();
      return tenantCustomizationSchema.parse(raw);
    },
    onSuccess: (data) => {
      queryClient.setQueryData(customizationKeys.current(), data);
    },
  });
}

// DELETE /api/v1/tenants/me/logo — clears the org logo (+ deletes the object).
export function useRemoveLogo() {
  const queryClient = useQueryClient();

  return useMutation<TenantCustomization, Error, void>({
    mutationFn: async () => {
      const raw = await apiClient.delete('api/v1/tenants/me/logo').json();
      return tenantCustomizationSchema.parse(raw);
    },
    onSuccess: (data) => {
      queryClient.setQueryData(customizationKeys.current(), data);
    },
  });
}
